import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import {
	withStyles,
	Typography,
	IconButton,
	Popover,
} from '@material-ui/core';

import {
	USER_TABLE_ADMINS_AND_MEMBERS,
	USER_TABLE_GUESTS,
	USER_TABLE_REDUCE_USERS
} from '../../config';

import { Info } from 'theme/icons';
import i18n from 'i18n/i18n';
const localize = i18n.loc.localize;

const styles = theme => ({
	infoIcon: {
		width: 16,
		height: 16,
		color: theme.palette.colors.white,
		backgroundColor: '#6F99BD',
		borderColor: '#6F99BD',
		padding: 0,
		'&:hover': {
			backgroundColor: `${theme.palette.colors.epsilonHover} !important`,
			borderColor: `${theme.palette.colors.epsilonHover} !important`
		}
	},
	infoIconWhite: {
		width: 15,
		height: 15,
		color: '#6F99BD',
		border: '1px solid #6F99BD',
		padding: 0,
		marginLeft: 10
	},
	/* popover */
	popover: {
		pointerEvents: 'none'
	},
	popoverText: {
		textAlign: 'left',
		marginBottom: 10
	},
	popoverTextSimple: {
		textAlign: 'left'
	}
});

@withStyles(styles)
class RolesTooltip extends Component {

	constructor(props) {
		super(props);
		this.handlePopoverClose = this.handlePopoverClose.bind(this);
		this.handlePopoverOpen = this.handlePopoverOpen.bind(this);

		this.state = {
			infoAnchor: null
		};
	}	

	handlePopoverOpen(event) {
		this.setState({ infoAnchor: event.currentTarget });
	}


	handlePopoverClose() {
		this.setState({ infoAnchor: null });
	}

	render() {
		const infoAnchor = this.state.infoAnchor;
		const open = Boolean(infoAnchor);

		const { classes, tableId } = this.props;

		return (
			<Fragment>
				<IconButton
					className={this.props.showGuestTooltip || this.props.text ? classes.infoIconWhite : classes.infoIcon}
					color='primary'
					component='span'
					disableRipple
					aria-owns={open ? `info-popover-${tableId || 'generic'}` : undefined}
					aria-haspopup='true'
					onMouseEnter={(e) => this.handlePopoverOpen(e)}
					onMouseLeave={() => this.handlePopoverClose()}>
					<Info />
				</IconButton>

				<Popover
					id={`info-popover-${tableId || 'generic'}`}
					className={classes.popover}
					open={open}
					anchorEl={infoAnchor}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'center'
					}}
					transformOrigin={{
						vertical: 'bottom',
						horizontal: 'center'
					}}
					disableRestoreFocus
					PaperProps={{
						style: { width: 300, padding: 20}
					}}							
					onClose={this.handlePopoverClose}
				>
					{!this.props.text && (
						<Typography variant='subtitle1' gutterBottom>
							{localize('users-roles-popover-title')}
						</Typography>
					)}
					{[USER_TABLE_REDUCE_USERS, USER_TABLE_ADMINS_AND_MEMBERS].includes(tableId) && (
						<Fragment>
							<Typography variant='body2' className={classes.popoverText}>
								<strong>{localize('users-roles-popover-admin')}: </strong>
								{localize('users-roles-popover-admin-description')}
							</Typography>
							<Typography variant='body2' className={classes.popoverText}>
								<strong>{localize('users-roles-popover-member')}: </strong>
								{localize('users-roles-popover-member-description')}
							</Typography>
						</Fragment>
					)}

					{this.props.text && (
						<Typography variant='body2' className={classes.popoverTextSimple}>
							{this.props.text}
						</Typography>						
					)}

					{([USER_TABLE_REDUCE_USERS, USER_TABLE_GUESTS].includes(tableId) || this.props.showGuestTooltip) && (
						<Typography variant='body2' className={classes.popoverText}>
							<strong>{localize('users-roles-popover-guest')}: </strong>
							{localize('users-roles-popover-guest-description')}
						</Typography>
					)}
				</Popover>				
			</Fragment>
		);
	}
}

RolesTooltip.propTypes = {
	classes: PropTypes.object,
	maxLength: PropTypes.number,
	tableId: PropTypes.string,
	infoAnchor: PropTypes.object,
	showGuestTooltip: PropTypes.bool,
	text: PropTypes.string
};

export default RolesTooltip;


// WEBPACK FOOTER //
// ./src/components/RolesTooltip/index.js